// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLayout_wrapper__Fnk7t","container":"AppLayout_container__1e18u","contentContainer":"AppLayout_contentContainer__L8Lev"};